/// <amd-module name="Release/Stats/ReleaseMetricsSection" />
import * as  React from "react";

import {
    Components,
    IVssComponentProperties,
    VssComponent,
    IVssComponentContext
} from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import * as Utils_String from "VSS/Core/Util/String";
import { PipelinesMetricsContainer, PipelinesMetricsPayload } from "Build/Stats/PipelinesMetricsContainer";
import * as Resources from "Build/Stats/Resources";
import { ITfsPageService } from "Tfs/Platform/Page";

import * as ReleaseContract from "Release/Client/Contracts/Release";
import { IReleaseRestClient } from "Release/Client/RestClient/Release";

const enum DefinitionMetrics {
    SuccessfulDeployments = "SuccessfulDeployments",
    FailedDeployments = "FailedDeployments",
    PartiallySuccessfulDeployments = "PartiallySuccessfulDeployments"
}

const enum ReleasePerfConstants {
    Area = "ReleaseMetricsSection",
    Scenario = "FetchReleaseMetricsClient"
}

interface ReleaseMetricsSectionProps extends IVssComponentProperties {
    numOfDays: number;
}

class ReleaseMetricsSection extends VssComponent<ReleaseMetricsSectionProps, {}> {

    public render(): JSX.Element | null {

        return (
            <PipelinesMetricsContainer
                succeededText={Resources.DeploymentsSucceeded}
                fetchMetrics={this._fetchMetrics}
                numOfDays={this.props.numOfDays}
            />
        );

    }

    private _fetchMetrics = (numOfDays: number): Promise<PipelinesMetricsPayload | null> => {

        const date = new Date();
        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        let passed: number = 0;
        let failed: number = 0;

        if (numOfDays === 1) {
            date.setDate(date.getDate() - numOfDays);
        }
        else {
            // since build supports day precision for 7,30 days range
            // make RM metrics behave similarly
            date.setUTCDate(date.getUTCDate() - numOfDays);
            // UTC midnight
            date.setUTCHours(0, 0, 0, 0);
        }

        const tfsPageData = this.context.pageContext.getService<ITfsPageService>("ITfsPageService").getData();

        if (tfsPageData && tfsPageData.project) {
            performanceService.startScenario(ReleasePerfConstants.Scenario, false);
            return this.context.pageContext.getRestClient<IReleaseRestClient>("IReleaseRestClient", { serviceInstanceType: "0000000d-0000-8888-8000-000000000000" })
                .getMetrics(tfsPageData.project.id, date)
                .then((data: ReleaseContract.Metric[]) => {
                    if (data) {
                        performanceService.endScenario(ReleasePerfConstants.Area, ReleasePerfConstants.Scenario, false);
                        for (let metric of data) {
                            if (Utils_String.equals(metric.name, DefinitionMetrics.SuccessfulDeployments, true)
                                || Utils_String.equals(metric.name, DefinitionMetrics.PartiallySuccessfulDeployments, true)) {
                                passed += metric.value;
                            }
                            else if (Utils_String.equals(metric.name, DefinitionMetrics.FailedDeployments, true)) {
                                failed = metric.value;
                            }
                        }

                        return {
                            passed: passed,
                            failed: failed
                        };
                    }
                    else {
                        this._endPerfScenario(performanceService);
                        return null;
                    }
                },
                () => {
                    this._endPerfScenario(performanceService);
                    return null;
                }
                );
        } else {
            return Promise.resolve(null);
        }

    }

    private _endPerfScenario(performanceService: IVssPerformanceService): void {
        performanceService.endScenario(ReleasePerfConstants.Area, ReleasePerfConstants.Scenario, false, undefined, { status: "failed" });
    }
}

Components.add("Pipelines.Releases.StatsComponent", ReleaseMetricsSection);
